export const Module = Object.freeze({
	Tasks: 'tasks',
});
